import { Link } from "react-router-dom";
import BgShape from "../images/hero/Airport.jpg";
import BgShape2 from "../images/hero/Tour.jpg";

import Pr8 from "../images/faq/pr8.jpeg";

function Options() {
  const bgImageStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1,
    objectFit: "cover",
    borderRadius: "15px",
  };

  const bannerContentStyle = {
    position: "relative",
    zIndex: 2,
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    borderRadius: "15px",
    transition: "all 0.3s ease-in-out",
  };

  const colStyle = {
    position: "relative",
    height: "350px",
    marginBottom: "20px",
    cursor: "pointer",
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <section
        className="banner-section"
        id="optionz"
        style={{ position: "relative", overflow: "hidden", marginTop: "-90px" }}
      >
        <div className="container">
          {/* First Row - Big Image */}
          <div className="row">
            <div className="col-12 col-md-12" style={colStyle}>
              <Link
                to="/atv-tours"
                style={{ backgroundColor: "transparent", display: "block", height: "100%" }}
                onClick={scrollToTop}
              >
                <img src={Pr8} alt="Background Shape" style={bgImageStyle} />
                <div className="banner-content" style={bannerContentStyle}>
                  <div className="banner-content__text">
                    <h2 style={{ fontSize: "4rem", fontWeight: "bold", color: "#fff" }}>
                      ATV Tours
                    </h2>
                    <p style={{ fontSize: "2.3rem", color: "white" }}>
                      <span style={{ color: "yellow", fontWeight: "bold" }}>
                        Click Here For Booking
                      </span>
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Second Row - Two Side by Side */}
          <div className="row">
            <div className="col-12 col-md-6" style={colStyle}>
              <Link
                to="/jetski-bookings"
                style={{ backgroundColor: "transparent", display: "block", height: "100%" }}
                onClick={scrollToTop}
              >
                <img src={BgShape} alt="Background Shape" style={bgImageStyle} />
                <div className="banner-content" style={bannerContentStyle}>
                  <div className="banner-content__text">
                    <h2 style={{ fontSize: "4rem", fontWeight: "bold", color: "#fff" }}>
                      Jetski Tours
                    </h2>
                    <p style={{ fontSize: "2.3rem", color: "white" }}>
                      <span style={{ color: "yellow", fontWeight: "bold" }}>
                        Click Here For Booking
                      </span>
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-12 col-md-6" style={colStyle}>
              <Link
                to="/drone-photoshoot"
                style={{ backgroundColor: "transparent", display: "block", height: "100%" }}
                onClick={scrollToTop}
              >
                <img src={BgShape2} alt="Background Shape" style={bgImageStyle} />
                <div className="banner-content" style={bannerContentStyle}>
                  <div className="banner-content__text">
                    <h2 style={{ fontSize: "4rem", fontWeight: "bold", color: "#fff" }}>
                      Drone Photo Shoots
                    </h2>
                    <p style={{ fontSize: "2.3rem", color: "white" }}>
                      <span style={{ color: "yellow", fontWeight: "bold" }}>
                        Click Here For Booking
                      </span>
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Options;
